module.exports = __webpack_public_path__ + "img/711837d.png";